import styled from 'styled-components';

export const SettingsLayout = styled.div`
  display: grid;
  gap: 20px;
  width: 100%;
  max-width: 1200px;
`;

export const SettingsSection = styled.section`
  min-width: 0;
  padding: 28px 24px;
  background: ${(p) => p.theme.colors.light};
  border-radius: 15px 15px 15px 0;
  ${(p) => p.theme.outsideShadowW02};

  @media (max-width: 639px) {
    padding: 22px 18px;
  }
`;

export const SectionHeader = styled.div`
  margin-bottom: 18px;

  h2 {
    margin: 0;
    color: ${(p) => p.theme.colors.primary500};
    font-size: ${(p) => p.theme.fontSizes.md};
    line-height: 1.35;
    text-wrap: balance;
  }

  p {
    max-width: 780px;
    margin-top: 8px;
    color: ${(p) => p.theme.colors.gray400};
    line-height: 1.6;
    text-wrap: pretty;
  }
`;

export const SettingsList = styled.div`
  display: grid;
`;

export const SettingsRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 18px;
  min-width: 0;
  padding: 16px 0;
  border-bottom: 1px solid ${(p) => p.theme.colors.gray100};

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
    border-bottom: 0;
  }

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    align-items: stretch;
    gap: 12px;
  }
`;

export const ItemContent = styled.div`
  min-width: 0;

  strong {
    display: block;
    color: ${(p) => p.theme.colors.gray500};
    overflow-wrap: anywhere;
  }

  span {
    display: block;
    margin-top: 4px;
    color: ${(p) => p.theme.colors.gray400};
    font-size: ${(p) => p.theme.fontSizes.sm};
    line-height: 1.5;
    overflow-wrap: anywhere;
  }
`;

export const ButtonCluster = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;

  @media (max-width: 767px) {
    justify-content: flex-start;

    > button {
      width: 100%;
    }
  }
`;

export const SectionActions = styled(ButtonCluster)`
  margin: 18px 0;
`;

export const VerificationPanel = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 320px) auto;
  align-items: end;
  gap: 16px;
  padding: 20px;
  background: ${(p) => p.theme.colors.surface};
  border-left: 4px solid ${(p) => p.theme.colors.primary500};

  @media (max-width: 639px) {
    grid-template-columns: 1fr;

    > button {
      width: 100%;
    }
  }
`;

export const ContactForm = styled.div`
  display: grid;
  grid-template-columns: minmax(150px, 0.45fr) minmax(0, 1fr) auto;
  align-items: end;
  gap: 18px;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid ${(p) => p.theme.colors.gray100};

  &.with-country-code {
    grid-template-columns: minmax(140px, 0.4fr) minmax(120px, 0.35fr) minmax(0, 1fr) auto;
  }

  @media (max-width: 900px) {
    &,
    &.with-country-code {
      grid-template-columns: 1fr 1fr;
    }
  }

  @media (max-width: 639px) {
    &,
    &.with-country-code {
      grid-template-columns: 1fr;
    }

    > button {
      width: 100%;
    }
  }
`;

export const TableScroll = styled.div`
  width: 100%;
  overflow-x: auto;
  overscroll-behavior-inline: contain;
`;

export const PreferenceTable = styled.table`
  width: 100%;
  min-width: 680px;
  border-collapse: collapse;

  th,
  td {
    padding: 14px 16px;
    border-bottom: 1px solid ${(p) => p.theme.colors.gray100};
    text-align: center;
  }

  thead th {
    color: ${(p) => p.theme.colors.primary500};
    font-weight: 700;
  }

  th:first-child {
    text-align: left;
  }

  tbody tr:last-child th,
  tbody tr:last-child td {
    border-bottom: 0;
  }

  input[type='checkbox'] {
    width: 20px;
    height: 20px;
    accent-color: ${(p) => p.theme.colors.primary500};
    cursor: pointer;
  }

  input[type='checkbox']:disabled {
    cursor: not-allowed;
  }
`;

export const EmptyState = styled.p`
  color: ${(p) => p.theme.colors.gray400};
  line-height: 1.6;
`;
